import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { ApiError } from "./api";

let onUnauthorized: () => void = () => {};
export function setUnauthorizedHandler(handler: () => void) {
  onUnauthorized = handler;
}

function handleAuthError(error: unknown) {
  if (error instanceof ApiError && error.status === 401) onUnauthorized();
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: handleAuthError }),
  mutationCache: new MutationCache({
    onError: handleAuthError,
    // Any write can change figures shown elsewhere (dashboard, invoice balance, customer balance,
    // weighted cost…). Every cached screen is marked stale so it reloads when it is shown again,
    // instead of serving 30 s of outdated data; the screen on display keeps its own targeted
    // invalidations. Mutations that write nothing (previews) opt out with `meta: { readOnly: true }`.
    onSuccess: (_data, _variables, _context, mutation) => {
      if (mutation.meta?.readOnly) return;
      void queryClient.invalidateQueries({ refetchType: "none" });
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      // Client errors won't fix themselves; only retry network and server failures.
      retry: (count, error) => count < 2 && !(error instanceof ApiError && error.status >= 400 && error.status < 500),
    },
  },
});
